import { Boules, Code, FaceMask, FilmReel, FilmStrip, Scissors, ShippingContainer, Shuffle, ShuffleSimple, SlidersHorizontal } from '@phosphor-icons/react';
import { ArrowSquareOut } from '@phosphor-icons/react/dist/ssr';
import { Flex } from 'antd';
import { createParticles } from '~/utils/function';

const pluginUrl = 'https://b23.tv/GtCIJAG';

const ScenePlugin = () => {
  return (
    <div className="carousel-slide carousel-four-slide">
      <div className="video-particles">{createParticles()}</div>
      <div className="carousel-four-decorations">
        {/* <div className="carousel-four-digital-rain">
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
          <div className="carousel-four-rain-column"></div>
        </div> */}
        <div className="carousel-four-hexagon-grid">
          <div className="carousel-four-hexagon"></div>
          <div className="carousel-four-hexagon"></div>
          <div className="carousel-four-hexagon"></div>
          <div className="carousel-four-hexagon"></div>
        </div>
        <div className="carousel-four-circuit-board">
          <div className="carousel-four-circuit-line carousel-four-circuit-horizontal"></div>
          <div className="carousel-four-circuit-line carousel-four-circuit-vertical"></div>
          <div className="carousel-four-circuit-line carousel-four-circuit-horizontal"></div>
        </div>
        <div className="carousel-four-hologram"></div>
      </div>
      <Flex className="container carousel-content-wrapper carousel-four-wrapper" align="center">
        <div className="flex-1 carousel-four-content">
          <div className="carousel-badge">
            <div className="carousel-badge-pulse"></div>
            <span>智能场景检测 · 精准镜头分割</span>
          </div>
          <h1 className="carousel-four-title">
            <span className="carousel-four-title-main">
              视频镜头<span className="carousel-four-highlight">分割大师</span>
            </span>
          </h1>
          <div className="carousel-four-services">
            <div className="carousel-four-service-item">
              <div className="carousel-four-service-icon">
                <FilmStrip />
              </div>
              <div className="carousel-four-service-content">
                <h4>智能场景检测</h4>
                <p>自动识别视频中的场景切换点</p>
              </div>
            </div>
            <div className="carousel-four-service-item">
              <div className="carousel-four-service-icon">
                <SlidersHorizontal />
              </div>
              <div className="carousel-four-service-content">
                <h4>灵活配置</h4>
                <p>支持自定义场景检测灵敏度</p>
              </div>
            </div>
            <div className="carousel-four-service-item">
              <div className="carousel-four-service-icon">
                <Code />
              </div>
              <div className="carousel-four-service-content">
                <h4>RESTful API</h4>
                <p>简洁易用的 HTTP 接口</p>
              </div>
            </div>
            <div className="carousel-four-service-item">
              <div className="carousel-four-service-icon">
                <ShippingContainer />
              </div>
              <div className="carousel-four-service-content">
                <h4>容器化部署</h4>
                <p>支持 Docker 一键部署</p>
              </div>
            </div>
          </div>
          <div className="custom-services">
            <div className="service-badge">
              <Shuffle size={32} /> 添加转场效果
            </div>
            <div className="service-badge">
              <ShuffleSimple size={32} /> 打乱镜头顺序
            </div>
            <div className="service-badge">
              <div className='boules-mask'><Boules className="boules-mask-inner" size={24} /></div>
               添加视频蒙版
            </div>
          </div>
          <div className="jump-extension mt-4">
            <a href={pluginUrl} target="_blank" style={{ color: 'white', textDecoration: 'none' }}>
              查看效果演示视频
            </a>
            <ArrowSquareOut size={32} className="jump-extension-icon" />
          </div>
        </div>
        <div className="scene-preview">
          <div className="scene-controls">
            <div className="scene-btn active">
              <Scissors size={24} />
            </div>
            <div className="scene-btn active">
              <Shuffle size={24} />
            </div>
            <div className="scene-btn active">
              <div className='boules-mask'>
              <Boules  className='boules-mask-inner'/>
              </div>
            </div>
          </div>
          <div className="scene-title">镜头分割</div>
          <div className="transition-demo">
            <div className="transition-box"></div>
            <div className="transition-box"></div>
            <div className="transition-box"></div>
            <div className="transition-box"></div>
          </div>
          <div className="scene-timeline">
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
            <div className="scene-marker"></div>
          </div>
        </div>
      </Flex>
    </div>
  );
};

export default ScenePlugin;
